// Validate critical environment variables before app initialization
export function validateEnvironment() {
  const required = {
    VITE_SUPABASE_URL: import.meta.env.VITE_SUPABASE_URL,
    VITE_SUPABASE_PUBLISHABLE_KEY: import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY,
  }

  const missing = Object.entries(required)
    .filter(([_, value]) => !value)
    .map(([key]) => key)

  if (missing.length > 0) {
    const error = `❌ Missing environment variables: ${missing.join(', ')}\n\nPlease restart your development server.`
    console.error(error)
    document.body.innerHTML = `
      <div style="display: flex; align-items: center; justify-content: center; min-height: 100vh; padding: 20px; font-family: system-ui;">
        <div style="max-width: 600px; text-align: center;">
          <h1 style="color: #ef4444; font-size: 24px; margin-bottom: 16px;">Configuration Error</h1>
          <p style="color: #666; margin-bottom: 8px;">Missing required environment variables:</p>
          <code style="background: #f3f4f6; padding: 8px; border-radius: 4px; display: block; margin: 16px 0;">${missing.join(', ')}</code>
          <p style="color: #666; font-size: 14px;">Please restart your development server to load the environment variables.</p>
        </div>
      </div>
    `
    throw new Error(error)
  }

  console.log('✅ Environment variables validated:', {
    VITE_SUPABASE_URL: required.VITE_SUPABASE_URL,
    VITE_SUPABASE_PROJECT_ID: import.meta.env.VITE_SUPABASE_PROJECT_ID,
    keyPrefix: required.VITE_SUPABASE_PUBLISHABLE_KEY?.substring(0, 20) + '...'
  })
}
